import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Articles = lazy(() => import('../pages/articles/page'));
const ArticleDetail = lazy(() => import('../pages/articles/[slug]'));
const AuthorDetail = lazy(() => import('../pages/authors/[id]'));
const Videos = lazy(() => import('../pages/videos/page'));
const Polls = lazy(() => import('../pages/polls/page'));
const PollDetail = lazy(() => import('../pages/polls/[pollId]'));
const Donate = lazy(() => import('../pages/donate/page'));
const Advertise = lazy(() => import('../pages/advertise/page'));
const Opinion = lazy(() => import('../pages/opinion/page'));
const AiLab = lazy(() => import('../pages/ai/page'));
const BharathManthan = lazy(() => import('../pages/bharath-manthan/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const AdminDashboard = lazy(() => import('../pages/admin/Dashboard'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/articles',
    element: <Articles />
  },
  {
    path: '/articles/:slug',
    element: <ArticleDetail />
  },
  {
    path: '/authors/:id',
    element: <AuthorDetail />
  },
  {
    path: '/videos',
    element: <Videos />
  },
  {
    path: '/opinion',
    element: <Opinion />
  },
  {
    path: '/ai',
    element: <AiLab />
  },
  {
    path: '/bharath-manthan',
    element: <BharathManthan />
  },
  {
    path: '/polls',
    element: <Polls />
  },
  {
    path: '/polls/:pollId',
    element: <PollDetail />
  },
  {
    path: '/donate',
    element: <Donate />
  },
  {
    path: '/advertise',
    element: <Advertise />
  },
  {
    path: '/privacy',
    element: <Privacy />
  },
  {
    path: '/terms',
    element: <Terms />
  },
  {
    path: '/admin',
    element: <AdminDashboard />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
